export const PALETTE_STORAGE_KEY = 'consolePalette.v1';

export const PALETTES = [
  { id: 'blue-sidebar', name: 'Blue sidebar', description: 'Light blue sidebar with a solid blue marker for the current page.' },
  { id: 'navy-sidebar', name: 'Navy sidebar', description: 'Dark navy sidebar with white text.' },
  { id: 'grey-sidebar', name: 'Grey sidebar', description: 'A darker version of the current neutral sidebar.' },
] as const;

export type PaletteId = (typeof PALETTES)[number]['id'];
export const DEFAULT_PALETTE: PaletteId = 'blue-sidebar';

export function resolvePalette(...choices: unknown[]): PaletteId {
  for (const choice of choices) {
    const palette = PALETTES.find((option) => option.id === choice);
    if (palette) return palette.id;
  }
  return DEFAULT_PALETTE;
}

export function applyPalette(...choices: unknown[]): PaletteId {
  const palette = resolvePalette(...choices);
  document.documentElement.setAttribute('data-palette', palette);
  return palette;
}

export function rememberPalette(value: PaletteId): void {
  try {
    localStorage.setItem(PALETTE_STORAGE_KEY, value);
  } catch (error) {
    // Palette persistence is best effort when site data is blocked.
  }
}

export function readRememberedPalette(): PaletteId {
  try {
    return resolvePalette(localStorage.getItem(PALETTE_STORAGE_KEY));
  } catch {
    // Site data can be blocked, so the built-in palette remains available.
    return DEFAULT_PALETTE;
  }
}
